const TYPE_LABELS: Record<string, string> = {
  food: 'Food',
  meal_delivery: 'Meal Delivery',
  meal_takeaway: 'Meal Takeaway',
  restaurant: 'Restaurant',
  grocery_or_supermarket: 'Grocery',
  supermarket: 'Supermarket',
  bakery: 'Bakery',
  health: 'Health',
  hospital: 'Hospital',
  doctor: 'Doctor',
  pharmacy: 'Pharmacy',
  local_government_office: 'Government Office',
  church: 'Church',
  school: 'School',
};

/**
 * Picks a human-readable category label from Google Place type strings.
 *
 * @param types - Place type tags from Google.
 * @returns Display label for ResourceCard category segment.
 */
export function deriveCategoryFromPlaceTypes(types: string[]): string {
  if (!types?.length) {
    return '';
  }

  for (const type of types) {
    const normalized = type.replace(/^.*\//, '').toLowerCase();
    if (TYPE_LABELS[normalized]) {
      return TYPE_LABELS[normalized];
    }
  }

  const first = types[0]?.replace(/^.*\//, '').replace(/_/g, ' ');
  if (!first) {
    return '';
  }

  return first.replace(/\b\w/g, char => char.toUpperCase());
}
